import { h, Component } from 'preact';

export default class Footer extends Component {
	render() {
		return (
			<footer>
		    <a href="mailto:samcorin@gmail.com"> Contact </a>
		    /
		    <a href="https://github.com/samcorin"> GitHub </a>
		    /
		    <a href="https://codepen.io/samcorin/"> Codepen </a>
		  </footer>
		);
	}
}



// WEBPACK FOOTER //
// ./components/footer/index.js